import { useKeybindController } from '@lessonup/pin-renderer';
import { BodyText, Button, IconAdd, IconReplace, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React, { useRef } from 'react';
import { useNonNullActivePin } from '../../../../../../context/EditorContext/hooks/useEditorState';
import { useEditorTranslation } from '../../../../../../hooks/useEditorTranslation';
import { getAudioSource } from '../../../../../../utils/sharedSettings.utils';

interface AudioUrlSettingProps {
  audioUrl: string;
  onAudioUrlChange: (audioUrl: string) => void;
  pinComponentId: string;
}

export const AudioUrlSetting: React.FC<AudioUrlSettingProps> = ({ audioUrl, onAudioUrlChange, pinComponentId }) => {
  const { t } = useEditorTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const pin = useNonNullActivePin();
  const keybindController = useKeybindController();

  const handleOpenAudioPicker = async () => {
    try {
      const sources = await getAudioSource({
        keybindController,
        modalDirection: 'left',
        modalAnchor: 'start',
        parentSelector: () => buttonRef.current,
        t,
        initialUrl: audioUrl,
        pinId: pin.id,
        pinComponentId,
      });

      if (sources) {
        if (sources.url) {
          onAudioUrlChange(sources.url);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <SpaceBetween direction="y" spacing={spacing.size8} data-testid="audio-url-setting">
      {audioUrl && <StyledUrl size="small">{audioUrl}</StyledUrl>}
      <Button
        ref={buttonRef}
        id="audio-url"
        onClick={handleOpenAudioPicker}
        buttonType="neutral"
        showStroke
        resizing="fixed"
        iconStart={audioUrl ? <IconReplace /> : <IconAdd />}
      >
        {audioUrl ? t('audioPinComponent.replaceAudio') : t('audioPinComponent.addAudio')}
      </Button>
    </SpaceBetween>
  );
};

const StyledUrl = styled(BodyText)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
